import { planTypes } from '@/common/constants';
import { getPlanLogo } from '@/common/plan-logo-map';
import { isFromZeConsumption } from '@/plans/EVENT_SAAS/helper/utils';
import { getTrackingProductNameByPlanType } from '@/aspects/trackings';

export default {
  key: planTypes[planTypes.EVENT_SAAS_CORE],
  data() {
    return {
      logo: getPlanLogo(planTypes.EVENT_SAAS_CORE),
      title: `${this.$t('billing.planform.title.eventsaascore')}${isFromZeConsumption() ? ' ' + this.$t('billing.events.ppa.title') : ''}`,
      subtitle: '',
      capacityKey: 'capacity',
      planType: planTypes.EVENT_SAAS_CORE,
      description: this.$t('billing.events.eventSaasCore.addon_desc'),
      totalLimitDesc: "",
      configDescription: this.$t('billing.events.eventSaasCore.desc'),
    };
  },
  computed: {
    trackingPlanKey() {
      return getTrackingProductNameByPlanType(this.planType);
    },
  }
};
